import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'form-steps',
  standalone: false,
  templateUrl: './form-steps.component.html',
  styleUrl: './form-steps.component.scss'
})
export class FormStepsComponent {
  @Input() pasos: string[] = [];
  @Output() cambioPaso = new EventEmitter<number>();
  // @Input() cambioPaso: number = 1;
  @Input() puedeAvanzar: boolean = false; 
  @Input() pasoActual = 1;

  avanzar() {
    console.log("parent cambioPaso", this.cambioPaso);
    console.log("parent puedeAvanzar", this.puedeAvanzar);
    if (!this.puedeAvanzar) {
      console.warn("No se puede avanzar: puedeAvanzar es false.");
      return;
    }

    if (this.pasoActual < this.pasos.length) {
      this.pasoActual++;
      this.cambioPaso.emit(this.pasoActual);
    }
  }

  retroceder() {
    if (this.pasoActual > 1) {
      this.pasoActual--;
      this.cambioPaso.emit(this.pasoActual);
    }
  }
}
